module.exports = __webpack_public_path__ + "static/media/tamanohikari.cac593b1.png";